export const roleRedirects: Record<string, string> = {
    '1': '/admin/dashboard',
    '2': '/admin/dashboard',
    '3': '/editor/dashboard',
    '4': '/shopper/dashboard',
    '5': '/areaManager/dashboard',
    '6': '/venueAdmin/dashboard'
  };
  